@for (value of values; track $index; let i = $index) {
<div class="history-version-card">
    <div class="history-version-header">
        <hr class="h-2 bg-valamardarkgray rounded-xl w-[10rem]">
        <p class="whitespace-nowrap text-black">Verzija {{ value.version }}</p>
        <hr class="h-2 bg-valamardarkgray rounded-xl w-full">
    </div>

    <div class="history-meta-grid">
        <div>
            <b>Izmjena:</b><p class="ml-5 inline-block">{{ value.modifiedByUser }}</p>
        </div>
        <div>
            <b>Vrijeme izmjene:</b><p class="ml-5 inline-block">{{ value.modifiedDate | date: "dd.MM.yyyy., HH:mm:ss" }}</p>
        </div>
    </div>
    <div class="history-state-row">
        <div class="flex items-center">
            <b>Aktivan:</b><mat-icon class="ml-5">{{ value.isActive ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        </div>
        <div class="flex items-center">
            <b>Skica:</b><mat-icon class="ml-5">{{ value.isDraft ? "check_box" : "check_box_outline_blank" }}</mat-icon>
        </div>
    </div>
    <div>
        <b>Naziv
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="valben-inline-select">
                <mat-select [(ngModel)]="langs[i]">
                    @for (lang of value.names | objKeys; track lang) {
                        <mat-option [value]="lang">{{ lang }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>:</b>
        <p class="ml-5">{{ value.names[langs[i]] }}</p>
    </div>
    <div>
        <b>Tip:</b>
        <p class="ml-5">{{ value.type }}</p>
    </div>
    <div>
        <b>Nadređena kategorija:</b>
        <p class="ml-5">{{ value.parentId | categoryNames }}</p>
    </div>
</div>
}
